import { render, staticRenderFns } from "./Requisition.vue?vue&type=template&id=b197e31a"
import script from "./Requisition.vue?vue&type=script&lang=js"
export * from "./Requisition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports